import { useAIChatStore } from '@/store/useAIChatStore';
import { AIContentInterface } from './AIContentInterface';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { Sparkles } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';
import { AIChatActions } from './AIChatActions';

export const AIChatSidePanel = () => {
  const { t } = useTranslation();
  const { isPanelOpen, setIsPanelOpen } = useAIChatStore();

  return (
    <Sheet open={isPanelOpen} onOpenChange={setIsPanelOpen}>
      <SheetContent
        side="right"
        className="w-[520px] sm:max-w-[520px] p-0 flex flex-col"
        iconClassName="size-4 top-5"
      >
        <div className="flex items-center gap-2 px-4 py-3 border-b shrink-0">
          <Sparkles className="size-4 text-secondary" />
          <SheetTitle className="text-sm font-semibold">{t('aiChat.pageTitle')}</SheetTitle>
          <AIChatActions />
        </div>

        <div className="flex-1 overflow-hidden">
          <AIContentInterface />
        </div>
      </SheetContent>
    </Sheet>
  );
};
